import { render } from "./Login.vue?vue&type=template&id=25edc20c&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=25edc20c&scoped=true&lang=scss"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25edc20c"]])

export default __exports__